import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { CompanyReadModel, useGetBuildingsByIdManagerQuery, usePutSpacesByIdManagerMutation } from '@client/api';
import { PageDetailContent } from '@client/toolkit';

import { PageContentAnimation } from '../../../../../components';
import { CompaniesCard } from '../../../components/companies-card/companies-card.component';

export function BuildingCompaniesManagersRoute() {
  const { buildingId } = useParams<{ buildingId: string }>();
  const { t } = useTranslation('type');
  const { t: tNotification } = useTranslation('notification');

  const {
    data: buildingManager,
    isFetching,
    refetch,
  } = useGetBuildingsByIdManagerQuery({ id: buildingId ?? '' }, { skip: !buildingId });
  const [putManagers] = usePutSpacesByIdManagerMutation();
  const handleEdit = (data: CompanyReadModel[]) => {
    putManagers({ id: buildingId as string, body: { tenantId: data[0]?.id ?? '' } })
      .unwrap()
      .then(() => {
        refetch();
        toast.success(tNotification('editing.fulfilled'));
      });
  };

  return (
    <PageDetailContent align="left">
      <PageContentAnimation>
        <CompaniesCard
          isLoading={isFetching}
          companies={buildingManager ? [buildingManager] : []}
          role={'Manager'}
          buildingId={buildingId}
          title={t(`RelationshipType.Manager`, { context: 'plural' })}
          onEdit={handleEdit}
        />
      </PageContentAnimation>
    </PageDetailContent>
  );
}
